interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalPath: string;
  ogType?: string;
  ogImage?: string;
  schemaJson?: object[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalPath,
  ogType = 'website',
  ogImage,
  schemaJson = [],
}: SEOHeadProps) {
  const baseUrl = window.location.origin;
  const fullCanonical = `${baseUrl}${__BASE_PATH__}${canonicalPath}`;

  const baseSchemas = [
    {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '国产精品视频精选推荐平台',
      url: `${baseUrl}${__BASE_PATH__}`,
      description: '汇聚海量国产精品视频，涵盖剧情、纪录、综艺、短片等多元类型。精心筛选高品质国产原创内容。',
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '国产精品视频精选推荐平台',
      url: `${baseUrl}${__BASE_PATH__}`,
    },
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: title,
      description: description,
      url: fullCanonical,
    },
    ...schemaJson,
  ];

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonical} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:site_name" content="国产精品视频精选推荐平台" />
      {ogImage && <meta property="og:image" content={ogImage} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}

      <script type="application/ld+json">{JSON.stringify(baseSchemas)}</script>
    </>
  );
}